import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Storage} from '@client/storage'
import {Tracking, TrackingEvent} from '@common/tracking'
import {IconButton} from '@components/common/base/buttons'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {useCompanyProjectsStore} from '@components/dashboard/company-projects/company-projects-store'
import TrelloLogo from './trello.svg'

const TwBanner = tw.div`
  relative
  isolate
  overflow-hidden
  rounded-8
  h-[132px]
  px-40
  py-[28px]
  flex
  items-center
  justify-between
  bg-grey-l100
  shadow-border-1
  shadow-grey-l60
`

const TwContent = tw.div`
  flex
  flex-col
  gap-4
`

const TwTitle = tw.div`
  font-semibold
  text-primary
  text-[40px]
  leading-[48px]
`

const TwSubTitle = tw.div`
  text-secondary
  text-20
  leading-6
`

const TwButton = tw.div`
  min-w-250
  h-[72px]
  w-fit
  cursor-pointer
  rounded-[14px]
  px-[21px]
  text-[24px]
  font-semibold
  flex
  items-center
  gap-8
  justify-center
  text-icon-invert
  bg-action-default
  hover:bg-action-hover
  active:bg-action-pressed
`

const TwClose = tw(IconButton)`
  absolute
  right-12
  top-12
`

const ImportFromTrelloBannerBase = ({
  onClick,
  onClose,
  className
}: {
  onClick: () => void
  onClose: () => void
  className?: string
}) => (
  <TwBanner className={className}>
    <TwContent>
      <TwTitle>
        <span>{Lang.msg.companyDashboard.banners.trello.importFrom}</span>
        <TrelloLogo className="ml-12" />
      </TwTitle>
      <TwSubTitle>
        {Lang.msg.companyDashboard.banners.trello.moveProjects}
      </TwSubTitle>
    </TwContent>
    <TwButton onClick={onClick}>
      <IconTabler
        icon="IconFileImport"
        viewBox="0 0 24 24"
        className="w-[28px] h-[28px]"
      />
      <span>{Lang.msg.companyDashboard.banners.trello.startImport}</span>
    </TwButton>
    <TwClose
      icon="IconX"
      size="small"
      wrapperSize="big"
      color="secondary"
      className="-m-4"
      onClick={onClose}
    />
    <img
      src="/img/banners/fire_emoji.png"
      alt=""
      className="absolute w-[100px] h-[100px] bottom-[-39px] right-[277px] rotate-[-15deg] -z-10"
    />
    <img
      src="/img/banners/fire_emoji.png"
      alt=""
      className="absolute w-[133px] h-[133px] bottom-[-66px] right-[259px] rotate-[-15deg] -z-10 [filter:blur(10px)] opacity-50"
    />
    <img
      src="/img/banners/fire_emoji.png"
      alt=""
      className="absolute w-[68px] h-[68px] bottom-[-29px] right-[-6px] rotate-[15deg] -z-10  [filter:blur(1px)]"
    />
  </TwBanner>
)

export const ImportFromTrelloBanner = observer(
  ({className, onClose}: {className?: string; onClose: () => void}) => {
    const [, store] = useCompanyProjectsStore()

    return (
      <ImportFromTrelloBannerBase
        onClick={() => {
          Tracking.send(TrackingEvent.trelloBannerClick)
          store.importFromTrelloOpen()
        }}
        onClose={() => {
          Tracking.send(TrackingEvent.trelloBannerHide)
          Storage.setItem('banner-import-from-trello', '0')
          onClose()
        }}
        className={className}
      />
    )
  }
)
